module.exports = new __parcel__URL__("lichess-logo-white.06acad04.svg").toString();